import { render, staticRenderFns } from "./BusinessNameDataUpdateDetails.vue?vue&type=template&id=61df964e&scoped=true&"
import script from "./BusinessNameDataUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateDetails.vue?vue&type=style&index=0&id=61df964e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df964e",
  null
  
)

export default component.exports